<section class="pageTitle tAlignLeft">
  <p class="darkGreyT w300 tAlignCenter">Enter the code from the two-factor app on your mobile device.</p>

  <hr class="darkWhiteBG marTop20 marBot20 opat25" />

  @if (backend && partialToken) {
  <form
    #nicknameForm
    (ngSubmit)="nicknameForm.submit()"
    [action]="
      stateService.nextPath
        ? '/auth/complete/' + backend + '/?next=' + stateService.nextPath
        : '/auth/complete/' + backend + '/'
    "
    method="post"
    role="form"
  >
    <input type="hidden" name="partial_token" value="{{ partialToken }}" />
    <label class="marTop40 oneColumn">
      <input
        type="text"
        id="nickname"
        name="nickname"
        class="field lightGreyBG50"
        [class.is-empty]="!nickname"
        [(ngModel)]="nickname"
        required
      />
      <span>
        <span>Nickname<em class="required">*</em></span>
      </span>
    </label>
    <section class="buttonGroupBottom tAlignCenter clearfix">
      <button
        class="button primary radius primaryBorder noMar marTop20 left width100"
        (click)="nicknameForm.submit()"
        type="submit"
      >
        <fa-icon [icon]="['far', 'badge-check']"></fa-icon> Submit
      </button>
    </section>
  </form>
  }
</section>
